import ModalystLogo from './ModalystLogo'

export default ModalystLogo
